import { NAV_ITEMS, type NavItem } from './navItems';

/** The destination for this path, including a child path under that destination. */
export function currentNavItem(pathname: string): NavItem | undefined {
  return NAV_ITEMS.find((item) => pathname === item.path || pathname.startsWith(`${item.path}/`));
}
